import { render, staticRenderFns } from "./DesignWorldCalendarTable.vue?vue&type=template&id=47a194c3&scoped=true"
import script from "./DesignWorldCalendarTable.vue?vue&type=script&lang=js"
export * from "./DesignWorldCalendarTable.vue?vue&type=script&lang=js"
import style0 from "./DesignWorldCalendarTable.vue?vue&type=style&index=0&id=47a194c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a194c3",
  null
  
)

export default component.exports